// extracted by mini-css-extract-plugin
module.exports = {"Hero":"styles_Hero__QXyWa","bg_1":"styles_bg_1__cRqPc","height":"styles_height__pRPpg"};